define('viewmodels/shell',['knockout', 'underscore', 'fastclick', 'jquery'], function (ko, _, FastClick, $) {

    var ShellViewModel = function (
        navigation,
        session,
        loadingState,
        ErrorAlert,
        getFields,
        getErrorField,
        onAppComposed,
        publishMenuOpened,
        publishMenuClosed,
        vocabulary,
        publishTopTabClicked
    ) {
        var self = this;

        self.onAppComposed = onAppComposed;

        self.router = navigation.getRouter();

        self.loadingState = loadingState;

        self.session = session;

        self.appComposed = ko.observable(false);

        self.menuActive = ko.observable(true);

        self.splashHook = ko.observable();

        self.menuActive.subscribe(_.skipFalsy(publishMenuOpened));
        self.menuActive.subscribe(_.onlyFalsy(publishMenuClosed));

        self.casumoLogo = getFields('casumo_logo');

        self.conditionalCasumoLogo = ko.pureComputed(function () {
            return self.showLogo() ?  self.casumoLogo() : null;
        });

        self.topBarAction = ko.pureComputed(function () {

            var activeViewModel = self.router.activeItem();

            if (activeViewModel && activeViewModel.topBarAction) {
                return ko.unwrap(activeViewModel.topBarAction);
            }

            return null;

        });

        self.topBar = ko.pureComputed(function () {

            var activeViewModel = self.router.activeItem();

            if (activeViewModel && activeViewModel.topBar) {
                return ko.unwrap(activeViewModel.topBar);
            }

            return null;

        });

        self.topTabSet =  ko.deferredComputed(function () {
            var activeRoute = self.router.activeItem;

            if (!activeRoute()) {
                return;
            }

            return activeRoute().subNav;

        });

        self.onTopTabClicked = function () {
            publishTopTabClicked();
        };

        self.section = self.topTabSet.property('name');

        self.showLogo = ko.pureComputed(function () {
            return !self.topTabSet() && !self.topBar();
        });

        self.activeModuleId = ko.pureComputed(function () {
            return self.router.activeInstruction().config.moduleId;
        });

        // Setup error messages for when players get logged out
        session.subscribeToExpiration(function () {
            // Close overlays, show message and navigate to homepage
            (new ErrorAlert(getErrorField('session_expired_title'), getErrorField('session_expired_message')))
                .show()
                .then(function () {
                    window.location = '';
                });
        });

        session.subscribeToTakenOver(function () {
            // Close overlays, show message and navigate to homepage
            (new ErrorAlert(getErrorField('session_invalidated_title'), getErrorField('session_invalidated_message')))
                .show()
                .then(function () {
                    window.location = '';
                });
        });
    };

    ShellViewModel.prototype.attached = function (view) {
        FastClick.attach(document.body);
    };

    ShellViewModel.prototype.openMenu = function () {
        this.menuActive(true);
    };

    ShellViewModel.prototype.closeMenu = function () {
        this.menuActive(false);
    };

    ShellViewModel.prototype.compositionComplete = function (element) {

        $(element).scrollLeft(0); // Always make sure the browser has not auto scrolled to focus fields

        _.delay(function () {
            this.appComposed(true);
            this.closeMenu();
            this.onAppComposed();
        }.bind(this), 300); // Let the menu show on first load before closing, but don't show the close menu button

    };

    return ShellViewModel;
});

